import capitalize from 'lodash/capitalize';

export const useFormatWorkflowDisplayName = () => {
  // Should be updated to use the workflowExtensions from the config
  // Need to make sure the workflowExtensions are populated immediately
  // when running in Portal

  return (
    workflowId: string,
    capitalizeName?: boolean,
    makePlural?: boolean,
  ) => {
    let label = workflowId;

    if (workflowId === 'abtest') {
      label = makePlural ? 'A/B tests' : 'A/B test';
    } else if (workflowId === 'rollout') {
      label = makePlural ? 'rollouts' : 'rollout';
    } else if (workflowId === 'analysis' || workflowId === 'reanalysis') {
      label = makePlural ? 'analyses' : 'analysis';
    }

    return capitalizeName && workflowId !== 'abtest'
      ? capitalize(label)
      : label;
  };
};
